<ng-container *ngIf="page$ | async as page; else loading">
<!--Page Header Start-->
<!--
  Un seul gabarit d'en-tête pour les deux cas.
  L'ancienne branche « avec image » s'appuyait sur les classes .page-header*
  du thème careox, qui n'est pas chargé par l'application : le bandeau
  s'effondrait à zéro pixel et le titre restait invisible. On réutilise donc
  .cuspage-hero, défini dans styles.css et déjà employé ailleurs, en y
  injectant l'image à la une lorsqu'elle existe.
-->
<section class="cuspage-hero" [class.cuspage-hero--image]="page.featured_image != null">
    <div class="cuspage-hero__bg" [style.background-image]="heroBackground(page)"></div>
    <div class="container">
        <div class="cuspage-hero__content">
            <h1 class="cuspage-hero__title">{{ translateField(page.title) }}</h1>
            <p class="cuspage-hero__sub" *ngIf="translateField(page.excerpt)">
                {{ translateField(page.excerpt) }}
            </p>
        </div>
    </div>
</section>
<!--Page Header End-->

<section class="about-four" style="color:black;padding-bottom:100px;width: 70%;margin-left: auto;margin-right: auto;">
        <div class="container">
            <div class="row"> 
                <div class="col-xl-12" [innerHTML]="translateField(page.content)">
                   
                </div>
            </div>
        </div>
    </section> 



<!-- ── Sections de la page ─────────────────────────────────────────── -->
<div class="page-sections" *ngIf="sectionsOf(page).length">
  <section class="page-section"
           *ngFor="let section of sectionsOf(page); trackBy: trackSection"
           [attr.data-type]="section.type">
    <div class="container">

      <header class="page-section__head" *ngIf="hasTitle(section)">
        <h2 class="page-section__title">{{ translateField(section.title) }}</h2>
        <p class="page-section__subtitle" *ngIf="translateField(section.subtitle)">
          {{ translateField(section.subtitle) }}
        </p>
      </header>

      <!-- Bloc texte enrichi -->
      <div class="page-section__text"
           *ngIf="section.type === 'text'"
           [innerHTML]="translateField(section.content)"></div>

      <!-- Bloc catégorie de documents -->
      <div class="page-section__files" *ngIf="section.type === 'documents'">
        <a class="doc-card"
           *ngFor="let file of section.files; trackBy: trackFile"
           [href]="file.download_url"
           rel="noopener">
          <span class="doc-card__ext">{{ file.type }}</span>
          <span class="doc-card__body">
            <span class="doc-card__title">{{ translateField(file.title) }}</span>
            <span class="doc-card__desc" *ngIf="translateField(file.description)">
              {{ translateField(file.description) }}
            </span>
            <span class="doc-card__meta">{{ fileMeta(file) }}</span>
          </span>
          <span class="doc-card__dl" aria-hidden="true">&#8595;</span>
        </a>

        <p class="page-section__empty" *ngIf="!section.files?.length">
          {{ 'PAGE.NO_DOCUMENTS' | translate }}
        </p>
      </div>

      <!-- Bloc galerie -->
      <div class="page-section__gallery" *ngIf="section.type === 'gallery'">
        <figure class="gal-item"
                *ngFor="let item of section.items; let gi = index"
                (click)="openLightbox(section.items, gi)"
                tabindex="0"
                (keydown.enter)="openLightbox(section.items, gi)">
          <img *ngIf="item.type === 'image'" [src]="item.url" alt="" loading="lazy" />
          <video *ngIf="item.type === 'video'" [src]="item.url" preload="metadata"></video>
          <span class="gal-item__zoom" aria-hidden="true"><i class="icofont-expand"></i></span>
        </figure>

        <p class="page-section__empty" *ngIf="!section.items?.length">
          {{ 'PAGE.NO_MEDIA' | translate }}
        </p>
      </div>

    </div>
  </section>
</div>

</ng-container>


<ng-template #loading>
    <p>Chargement...</p>
</ng-template>

<!-- ── Visionneuse des galeries de section ───────────────────────────── -->
<app-lightbox
    [media]="lightboxMedia"
    [(index)]="lightboxIndex"
    [open]="lightboxOpen"
    (closed)="lightboxOpen = false">
</app-lightbox>
